import { render, staticRenderFns } from "./onemarket.vue?vue&type=template&id=eedcd196"
import script from "./onemarket.vue?vue&type=script&lang=js"
export * from "./onemarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eedcd196')) {
      api.createRecord('eedcd196', component.options)
    } else {
      api.reload('eedcd196', component.options)
    }
    module.hot.accept("./onemarket.vue?vue&type=template&id=eedcd196", function () {
      api.rerender('eedcd196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/onemarket.vue"
export default component.exports